import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { skills } from "./roles_skills";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const skillsApi = createApi({
  reducerPath: "skillsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      const datos = await localStorage.getItem("persist:root");
      if (typeof datos === "string") {
        const parse = JSON.parse(datos);
        const user = JSON.parse(parse.user);
        if (user.token) {
          headers.set("Authorization", `Bearer ${user.token}`);
        }
      }
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllSkills: builder.query<{ data: skills[] }, void>({
      query: () => ({
        url: `/api/guardian/skills?order=ASC`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllSkillsQuery } = skillsApi;
